import styled from 'styled-components';
import { cssVars } from '../../shared/lib/styledTheme';
import { Select as BaseSelect } from '../../shared/ui/Select';

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-color: ${cssVars.bgColor};
  overflow-y: auto;
`;

export const SearchHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
  background-color: ${cssVars.bgSecondary};
`;

export const SearchTitle = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin: 0;
`;

export const FiltersSection = styled.div`
  padding: 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
  background-color: ${cssVars.bgSecondary};
`;

export const FiltersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FilterLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${cssVars.textPrimary};
`;

export const FilterInput = styled.input`
  padding: 10px 12px;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  background-color: ${cssVars.bgColor};
  color: ${cssVars.textPrimary};
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: ${cssVars.primary};
  }
`;

export const FilterSelect = styled(BaseSelect)`
  width: 100%;
`;

export const FilterActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

export const ClearButton = styled.button`
  padding: 8px 16px;
  background-color: ${cssVars.bgColor};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  color: ${cssVars.textPrimary};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
  }
`;

export const ResultsCount = styled.div`
  font-size: 14px;
  color: ${cssVars.textSecondary};
  font-weight: 500;
`;

export const ResultsSection = styled.div`
  flex: 1;
  padding: 24px;
`;

export const Loading = styled.div`
  text-align: center;
  padding: 48px;
  color: ${cssVars.textSecondary};
  font-size: 16px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px;
`;

export const EmptyStateText = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${cssVars.textPrimary};
  margin-bottom: 8px;
`;

export const EmptyStateSubtext = styled.div`
  font-size: 14px;
  color: ${cssVars.textSecondary};
`;

export const TicketsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 16px;
`;

export const TicketCard = styled.div`
  background-color: ${cssVars.bgSecondary};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${cssVars.bgTertiary};
    border-color: ${cssVars.primary};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

export const TicketCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const TicketCardTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  flex: 1;
`;

export const TicketCardStatus = styled.div<{ $status: string }>`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => 
    props.$status === 'active' ? '#4CAF50' : cssVars.textTertiary};
  color: ${cssVars.white};
`;

export const TicketCardInfo = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
  font-size: 13px;
  color: ${cssVars.textSecondary};
  flex-wrap: wrap;
`;

export const TicketCardClient = styled.div``;

export const TicketCardSite = styled.div<{ $site: string }>`
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background-color: ${props => props.$site === 'hudle' ? '#4CAF50' : '#2196F3'};
  color: ${cssVars.white};
`;

export const TicketCardPriority = styled.div<{ $priority: string }>`
  color: ${props => {
    switch (props.$priority) {
      case 'urgent': return '#f44336';
      case 'high': return '#ff9800';
      case 'medium': return '#2196F3';
      default: return cssVars.textSecondary;
    }
  }};
  font-weight: 500;
`;

export const TicketCardPreview = styled.div`
  font-size: 13px;
  color: ${cssVars.textTertiary};
  line-height: 1.4;
  margin-top: 8px;
`;

